import React from 'react';

import styled from 'styled-components';

import {colors} from '@app/styles/theme';

import {Icon} from '@shared/ui/Icon';
import {Input, InputProps} from '@shared/ui/Input';
import {Label} from '@shared/ui/Label';

interface DatePickerInputProps extends InputProps {
    placeholder?: string;
    className?: string;
    label?: string;
    hasError?: boolean;
    isRequired: boolean;
}

const CustomInput = styled(Input)`
    input {
        cursor: pointer;
    }
`;

export class DatePickerInput extends React.Component<DatePickerInputProps> {
    render() {
        const {label, hasError, isRequired, ...otherProps} = this.props;
        return (
            <Label text={label} hasError={hasError} isRequired={isRequired}>
                <CustomInput
                    {...otherProps}
                    adornment={<Icon name="calendar" size={16} color={colors.brandPrimary} />}
                    hasError={hasError}
                    disableAdornmentPointerEvents
                />
            </Label>
        );
    }
}
